exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".page-name .name-input {\n  padding: 48px 0 32px; }\n\n.page-name .or {\n  font-size: 16px;\n  line-height: 1.5;\n  color: #727272;\n  text-align: center;\n  padding: 20px 0; }\n\n.page-name .fb-button {\n  text-align: center;\n  line-height: 56px;\n  margin: 0 auto;\n  height: 56px;\n  max-width: 328px;\n  width: 100%;\n  display: block;\n  font-size: 18px;\n  font-weight: 500;\n  border-radius: 100px;\n  background: #3c5a99;\n  color: #fff;\n  -webkit-box-shadow: 0px 6px 20px 0px rgba(0, 0, 0, 0.15);\n  box-shadow: 0px 6px 20px 0px rgba(0, 0, 0, 0.15);\n  font-weight: 500;\n  -webkit-transition: all 150ms ease-in-out;\n  -o-transition: all 150ms ease-in-out;\n  transition: all 150ms ease-in-out; }\n\n.page-name .error-text {\n  color: #e05139;\n  line-height: 16px;\n  font-size: 13px;\n  margin-bottom: 8px;\n  height: 16px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/pages/Name/styles.scss
// module id = 1299
// module chunks = 0